import { useCallback, useContext, useState, useEffect } from 'react'

import { useSelector } from 'react-redux'

import ContactPersonSpecialitiesSchoolWidget from '../../../Components/shared/ContactPersonSpecialitiesSchoolWidget'
import { getSchoolSpecialities } from '../../../utils/api/school'
import ContactPersonTable from './ContactPersonTable'
import { getSchoolSpecialitiesContactPersons } from '../../../utils/api/contactPerson'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const ContactPersonsSchoolMaccs = () => {
  const { user } = useContext(GlobalContext)

  const t = useSelector(selectTranslate)

  const additionalActions = [
    {
      iconName: 'graduation-cap',
      type: 'primary',
      title: t('Display specialities for this user'),
      onClick: u => setSelectedContactPersonSpeciality(u)
    }
  ]

  const [contactPersons, setContactPersons] = useState([])
  const [optionsSelect, setOptionSelect] = useState([])
  const [selectValue, setSelectValue] = useState(null)
  const [loading, setLoading] = useState(true)
  const [selectedContactPersonSpeciality, setSelectedContactPersonSpeciality] = useState(null)

  const getContactPersons = useCallback(schoolSpeciality => {
    const parameters = { visibility: 'internal' }
    setLoading(true)

    if (schoolSpeciality) {
      parameters.schoolSpeciality = schoolSpeciality
    }

    getSchoolSpecialitiesContactPersons(user, user.school, parameters).then(({ data }) => {
      setContactPersons(data)
    }).finally(() => setLoading(false))
  }, [user])

  useEffect(() => {
    if (user.school) {
      getSchoolSpecialities(user, user.school, { excludeRoot: true, contexts: ['contact-persons'] }).then(({ data }) => {
        setOptionSelect(data.map(schoolSpeciality => {
          schoolSpeciality.name = schoolSpeciality.specialityYear.specialityAbbreviation + ' (' + schoolSpeciality.specialityYear.studyYearName + ')'
          return schoolSpeciality
        }))
      })
    }
  }, [user.school])

  useEffect(() => {
    if (user.school) {
      setLoading(true)
      getContactPersons()
    }
  }, [getContactPersons, user])

  const handleChangeSelectSpeciality = value => {
    setSelectValue(value)
    getContactPersons(value === 'all' ? null : value)
  }

  return (
    <>
      <ContactPersonTable
        contactPersons={contactPersons}
        loading={loading}
        additionalActions={additionalActions}
        onChangeSelect={handleChangeSelectSpeciality}
        allOptionText={t('All specialities')}
        selectValue={selectValue}
        optionsSelect={optionsSelect}
      />
      <ContactPersonSpecialitiesSchoolWidget
        user={selectedContactPersonSpeciality}
        school={user.school}
        onClose={() => setSelectedContactPersonSpeciality(null)}
      />
    </>
  )
}
export default ContactPersonsSchoolMaccs
